import React from 'react';
import PrintifyProducts from '../components/PrintifyProducts';

const MHBStore = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 p-4">
      <div className="max-w-7xl mx-auto">
        
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Conscious Commerce 🌱
          </h1>
          <p className="text-xl text-blue-200">
            Triple Win™ Commerce Model
          </p>
          <p className="text-blue-300 mt-3 max-w-3xl mx-auto">
            With our Triple Win model, every purchase helps us grow, you get fun merch, and society benefits—with 33% of proceeds going straight to a designated charity.
          </p>
        </div>

        {/* Products */}
        <PrintifyProducts layout="full" />

        {/* Back to Dashboard */}
        <div className="mt-8 text-center">
          <a 
            href="/dashboard"
            className="inline-flex items-center px-6 py-3 bg-white/10 hover:bg-white/20 text-white rounded-xl transition-colors"
          >
            ← Back to Main Feed
          </a>
        </div>
      </div>
    </div>
  );
};

export default MHBStore;